// One sentence shown at the top of the Leaderboard, under the heading.
// Rewrite it each week. Set it to "" to hide the line.
export const WEEKLY_LINE = "New money leader boys and it's not even close!";
